import { v4 as uuidv4 } from 'uuid'

export function generateAriaId() {
    return uuidv4()
}
